import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const showStoreStockBtnSX:SxProps = {
    columnGap:1,
    borderWidth:1,
    '&:hover':{
        borderWidth:1,
    },    
    width:'85%'
}

export const showStoreStockMdlSX:SxProps = {
    position:'absolute',
    right:0,
    bgcolor:'#fff',
    width: globalBreak({mobile:'97%', desktop:'40%'}),
    borderRadius:0,
    maxHeight:globalBreak({mobile:'90vh',desktop:'100vh'}),
    minHeight:globalBreak({mobile:'95vh',desktop:'98vh'}),
    overflowY:'auto'
}

export const storeStockMdlTitleSX:SxProps = {
    flexDirection:'row',
    justifyContent:'space-between',
    alignItems:'center',
    px:3,
    py:2,
    borderBottom:'1px solid #E2E2E2',
    bgcolor:'navbar.primary'
}

export const storeStockMdlContentSX:SxProps = {
    px:3,
    py:2,
    borderBottom:'1px solid #E2E2E2'
}

export const storeSearchPanelSX:SxProps = {
    mt:2,
    pt:1,
    pb:2,
    pr:1,
    borderTop:'1px solid #E2E2E2',
}

export const storeStockAvailabilitySX:SxProps = {
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"flex-end",
    columnGap:0.5,
    minWidth: '60%'
}